<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :applyTranslate="false"
              :isRequiredFarms="true"
              :isRequiredLots="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4"
              classLots="col-12 col-sm-6 col-md-6 col-lg-4"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <sticky-legend-compliance v-if="validateTableData()" />
      <card v-if="validateTableData()">
        <el-collapse
          class="custom-el-collapse"
          v-model="farmActiveName"
          accordion
          @change="loadData"
        >
          <el-collapse-item
            class="custom-collapse-item collapse-data"
            v-for="farm in getFarms"
            :name="`${farm.id}`"
            :key="farm.id"
          >
            <template slot="title">
              <span style="text-transform: capitalize">
                <strong>{{ $t('common_words.farm') }}: </strong>
                {{ farm.name }}
              </span>
            </template>
            <div class="mb-5" v-if="Object.keys(seletedData).length > 0">
              <div
                class="table-responsive pb-2"
                v-for="(dataEvaluations, evaluation) in seletedData.columns"
                :key="evaluation"
                style="overflow-x: scroll"
              >
                <table
                  class="el-table table-striped table-bordered mt-4"
                  aria-describedby="table-subcategory"
                  style="min-width: max-content"
                >
                  <thead-compliance
                    :dataEvaluations="dataEvaluations"
                    :evaluation="evaluation"
                  />
                  <tbody-compliance
                    :dataEvaluations="dataEvaluations"
                    :evaluation="evaluation"
                    :seletedData="seletedData"
                  >
                    <template slot="trTotal">
                      <total-row
                        :dataEvaluations="dataEvaluations"
                        :evaluation="evaluation"
                        :seletedData="seletedData"
                      />
                    </template>
                  </tbody-compliance>
                </table>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import Legend from './Legend';
import MixinFilter from 'src/util/mixinFilter';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinMethods from './mixin-methods';
import SweetAlert from 'src/class/Alerts';
import TbodyCompliance from './TbodyCompliance';
import TheadCompliance from './TheadCompliance';
import TotalRow from './TotalRow';
import i18n from 'src/i18n';

export default {
  components: {
    [Filter.name]: Filter,
    [Legend.name]: Legend,
    [TbodyCompliance.name]: TbodyCompliance,
    [TheadCompliance.name]: TheadCompliance,
    [TotalRow.name]: TotalRow,
  },
  data() {
    return {
      activeName: 'filter',
      farmActiveName: '0',
      model: {
        farm_id: [],
        lot_id: [],
      },
      lots: [],
      valueCollapse: null,
      farms: null,
      columns: null,
      seletedData: {},
      openCollapse: false,
      subcategory: null,
    };
  },
  mixins: [MixinMenu, MixinMasters, MixinFilter, MixinMethods],
  computed: {
    getFarms() {
      if (!this.validateTableData()) {
        return [];
      }

      const farms = [];
      for (const farm of Object.values(this.tableData.farms)) {
        const columnsFarm = Object.values(this.tableData.columns[farm.id]);
        for (const column of columnsFarm) {
          const filteredColumns = Object.entries(column).filter(
            ([_, dataColumn]) => {
              return dataColumn.containObjetive || dataColumn.general;
            }
          );

          if (
            filteredColumns.length > 0 &&
            !farms.some((existingFarm) => existingFarm.id === farm.id)
          ) {
            farms.push({ id: farm.id, name: farm.name });
          }
        }
      }

      return farms;
    },
  },
  methods: {
    validateTableData() {
      return this.tableData && Object.keys(this.tableData).length > 0;
    },
    loadData() {
      this.openCollapse = !this.openCollapse;
      if (this.farmActiveName && this.farmActiveName !== '') {
        this.seletedData = {
          columns: this.tableData.columns[this.farmActiveName],
          table: this.tableData.table[this.farmActiveName],
        };
      } else {
        this.seletedData = {};
      }
    },
    handleFilter(data) {
      this.seletedData = {};
      this.generalAVG = 0;
      this.tableData = [];
      this.farmActiveName = '';
      this.dataFilter = { ...data };
      this.getDataSamplingReport();
    },
    getDataSamplingReport() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'advanced/audits/compliance';
      Axios.postMasters(data)
        .then((response) => {
          if (response.data.data.farms.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.tableData = response.data.data;
            if (!this.openCollapse) {
              setTimeout(() => {
                document
                  .getElementsByClassName('collapse-data')[0]
                  .getElementsByClassName('el-collapse-item__header')[0]
                  .click();
                this.openCollapse = true;
              }, 50);
            } else {
              this.farmActiveName = `${this.dataFilter.farm[0]}`;
              this.loadData();
            }
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
  },
};
</script>
